import iconL0 from 'assets/icons/levels/iconL0.png';
import iconL1 from 'assets/icons/levels/iconL1.png';
import iconL2 from 'assets/icons/levels/iconL2.png';
import iconL3 from 'assets/icons/levels/iconL3.png';
import iconL4 from 'assets/icons/levels/iconL4.png';
import iconL5 from 'assets/icons/levels/iconL5.png';
import { AccordionCustom } from 'components';
import {
  tour_06,
  tour_06a,
  tour_18,
  TOUR_18_MUTED_LEVELS_END,
  TOUR_18_MUTED_LEVELS_START,
} from 'constants/tour';
import { AccordionDataGeneralL0 } from 'pages/Inspections/CreateInspection/L0/GeneralData/config/generalData';
import { AccordionDataServicesL0 } from 'pages/Inspections/CreateInspection/L0/Services/config/services';
import { AccordionDataStructureL0 } from 'pages/Inspections/CreateInspection/L0/Structures/config/structure';
import { AccordionDataSuperstructureL0 } from 'pages/Inspections/CreateInspection/L0/SuperStructures/config/superstructure';
import { AccordionDataGeneralL1 } from 'pages/Inspections/CreateInspection/L1/GeneralData/config/generalData';
import { AccordionDataServicesL1 } from 'pages/Inspections/CreateInspection/L1/Services/config/services';
import { AccordionDataStructureL1 } from 'pages/Inspections/CreateInspection/L1/Structures/config/structures';
import { AccordionDataSuperstructureL1 } from 'pages/Inspections/CreateInspection/L1/SuperStructures/config/superstructure';
import L2Cda from 'pages/Inspections/CreateInspection/L2/L2Cda';
import { L3Idraulica } from 'pages/Inspections/CreateInspection/L3/L3Idraulica';
import { TabL0 } from 'pages/Structures/StructureDetail/Summary/TabL0/TabL0';
import { TabL1 } from 'pages/Structures/StructureDetail/Summary/TabL1/TabL1';
import { TabL3 } from 'pages/Structures/StructureDetail/Summary/TabL3/TabL3';
import { TabOverview } from 'pages/Structures/StructureDetail/Summary/TabOverview/TabOverview';
import { hasL3ModuleAccess } from 'utils/l3Access';
import { TabCreateInspection } from './TabCreateInspection';

export const avatar = [
  {
    initial: 'AB',
    class: 'orange',
  },
  {
    initial: 'BC',
    class: 'green',
  },
  {
    initial: 'CD',
    class: 'red',
  },
  {
    initial: 'MB',
    class: 'white',
  },
  {
    initial: 'MB',
    class: 'white',
  },
  {
    initial: 'MB',
    class: 'white',
  },
  {
    initial: 'MB',
    class: 'white',
  },
  {
    initial: 'MB',
    class: 'white',
  },
];

export const contextAccordionTabsL0 = [
  {
    label: 'Contesto dati generali',
    content: (
      <AccordionCustom checkExpanded accordions={AccordionDataGeneralL0} />
    ),
    value: 0,
  },
  {
    label: 'Struttura',
    content: (
      <AccordionCustom checkExpanded accordions={AccordionDataStructureL0} />
    ),
    value: 1,
  },
  {
    label: 'Elementi accessori',
    content: (
      <AccordionCustom
        accordions={AccordionDataSuperstructureL0}
        checkExpanded
      />
    ),
    value: 2,
  },
  {
    label: 'Servizi',
    content: (
      <AccordionCustom checkExpanded accordions={AccordionDataServicesL0} />
    ),
    value: 3,
  },
  {
    label: 'Riepilogo',
    content: <TabL0 />,
    value: 4,
  },
];

export const contextAccordionTabsL1 = [
  {
    label: 'Contesto dati generali',
    content: (
      <AccordionCustom checkExpanded accordions={AccordionDataGeneralL1} />
    ),
    value: 0,
  },
  {
    label: 'Struttura',
    content: (
      <AccordionCustom checkExpanded accordions={AccordionDataStructureL1} />
    ),
    value: 1,
  },
  {
    label: 'Elementi accessori',
    content: (
      <AccordionCustom
        accordions={AccordionDataSuperstructureL1}
        checkExpanded
      />
    ),
    value: 2,
  },
  {
    label: 'Servizi',
    content: (
      <AccordionCustom checkExpanded accordions={AccordionDataServicesL1} />
    ),
    value: 3,
  },
  {
    label: 'Riepilogo',
    content: <TabL1 />,
    value: 4,
  },
];

export const contextAccordionTabsOthers = [
  {
    label: 'Contesto dati generali',
    content: <p></p>,
    value: 0,
  },
  {
    label: 'Struttura',
    content: <p></p>,
    value: 1,
  },
  {
    label: 'Sovrastruttura',
    content: <p></p>,
    value: 2,
  },
  {
    label: 'Servizi',
    content: <p></p>,
    value: 3,
  },
  {
    label: 'Riepilogo',
    content: <p></p>,
    value: 4,
  },
];

// l3: oggetto ritornato da useInspectionL3() in CreateInspection.jsx —
// "alzato" fin qui (invece di essere istanziato dentro L3Idraulica) per
// poter mostrare Salva/Annulla nell'header condiviso esattamente come
// per L0/L1 (CreateInspectionButtons.jsx). Stesso pattern di
// getOverviewTab({...}) sotto, non un'eccezione nuova.
// isL3Activity: la tab L3 è selezionabile solo se l'attività correntemente
// aperta è essa stessa un'attività L3 (flag BE, propagato da
// useInspection.js) — un'attività L0,L1,L2 non deve mai poterla aprire,
// indipendentemente da eventuali attività L3 pregresse sulla struttura
// (punto cliente, aggiornato 2026-08-18 — sostituisce il precedente gate
// su checkHasL3History.js/hasL3History, ora rimosso).
// Issue #1021, riapertura 2026-09-24 — richiesta esplicita dell'utente dopo
// più tentativi: finché non sono arrivate TUTTE le chiamate che determinano
// isL3Activity, nessuna tab deve risultare "attiva" — né come stile
// (selezionata/blu) né come contenuto mostrato. `isL3ActivityLoading`
// gestisce qui la parte "quali tab, quanto mutate/disattivate"; la parte
// "nessuna selezionata, nessun contenuto montato" è nel chiamante
// (CreateInspection.jsx, prop `tabsLoading` su TabCreateInspection).
export const getNewInspectionTabs = ({ l3, isL3Activity, inspectionStatus }) => {
  const isL3ActivityLoading = isL3Activity === undefined;
  // Durante il caricamento L0/L1/L2 restano mutate/disattivate esattamente
  // come lo sarebbero se l'attività risultasse L3 — una volta risolto,
  // torna il comportamento originale (mutate solo se l'attività è
  // realmente L3).
  const muteL012 = isL3ActivityLoading || isL3Activity;

  return [
    {
      level: '',
      label: 'Overview',
      content: <TabOverview />,
      disabled: false,
      value: 0,
    },
    {
      level: 'L0',
      label: 'Censimento e anagrafica',
      icon: <img src={iconL0} alt="L0" />,
      iconPosition: 'start',
      content: (
        <TabCreateInspection
          className={`${tour_06.step_04} ${tour_06a.step_01}`}
          tabs={contextAccordionTabsL0}
        />
      ),
      // Issue #1021, punto 25 — L0/L1/L2 non pertinenti a un'attività di tipo
      // L3 (modificabili solo dentro un'attività L0,1,2): in grigio quando
      // l'attività aperta è L3, invariate (sempre abilitate) altrimenti —
      // simmetrico al gate `!isL3Activity` già su L3 poco sotto.
      // Riapertura 2026-09-04, punto 32 — "in grigio" non significa "non
      // cliccabile": `disabled` (MUI) bloccava anche il click, ora solo
      // `muted` (puramente visivo, vedi TabCreateInspection.style.js) — a
      // parte durante il caricamento, dove "disattivate" nel senso
      // letterale (non cliccabili) è la richiesta.
      muted: muteL012,
      disabled: isL3ActivityLoading,
      className: TOUR_18_MUTED_LEVELS_START,
      value: 1,
    },
    {
      level: 'L1',
      label: 'Ispezioni',
      content: (
        <TabCreateInspection
          className={`${tour_06.step_04} ${tour_06a.step_01}`}
          tabs={contextAccordionTabsL1}
        />
      ),
      icon: <img src={iconL1} alt="L1" />,
      iconPosition: 'start',
      muted: muteL012,
      disabled: isL3ActivityLoading,
      value: 2,
    },
    {
      level: 'L2',
      label: 'Classi di attenzione',
      icon: <img src={iconL2} alt="L2" />,
      iconPosition: 'start',
      content: <L2Cda />,
      muted: muteL012,
      disabled: isL3ActivityLoading,
      className: TOUR_18_MUTED_LEVELS_END,
      value: 3,
    },
    // Issue #1021, riapertura 2026-09-04, punto 38 — un'attività L0,1,2 non
    // deve mostrare affatto la tab L3 (prima solo `disabled: !isL3Activity`,
    // restava visibile e grigia): va omessa del tutto dall'array quando
    // l'attività aperta non è essa stessa L3, non solo disattivata. Durante
    // il caricamento resta presente (mutata+disabled) per lo stesso motivo
    // di muteL012 sopra: evitare che "compaia dal nulla" un istante dopo.
    ...(isL3Activity || isL3ActivityLoading
      ? [
          {
            level: 'L3',
            label: 'Valutazione preliminare',
            icon: <img src={iconL3} alt="L3" />,
            iconPosition: 'start',
            // Guida al primo accesso, tour_18, step "Livello 3" — un solo
            // elemento, nessun problema di spanning come per L0/L2 sopra: la
            // classe del tour va direttamente sulla tab.
            className: tour_18.step_01,
            muted: isL3ActivityLoading,
            disabled: isL3ActivityLoading,
            content: (
              <L3Idraulica
                methods={l3.methods}
                handleSubmit={l3.handleSubmit}
                onSubmit={l3.onSubmit}
                inspectionStatus={inspectionStatus}
              />
            ),
            value: 4,
          },
        ]
      : []),
    // Issue #1021, punto 25 — L4/L5 non sono livelli implementati (erano già
    // sempre `disabled: true`, mai apribili): il cliente vuole che nell'attività
    // non compaiano proprio, non solo in grigio. Commentate, non rimosse, per
    // riattivarle facilmente quando i livelli verranno implementati.
    // {
    //   level: 'L4',
    //   label: 'Verifica accurata',
    //   icon: <img src={iconL4} alt="L4" />,
    //   iconPosition: 'start',
    //   content: <TabCreateInspection tabs={contextAccordionTabsOthers} />,
    //   disabled: true,
    //   value: 5,
    // },
    // {
    //   level: 'L5',
    //   label: 'Sorveglianza e monitoraggio',
    //   icon: <img src={iconL5} alt="L5" />,
    //   iconPosition: 'start',
    //   content: <TabCreateInspection tabs={contextAccordionTabsOthers} />,
    //   disabled: true,
    //   value: 6,
    // },
  ];
};

export const getOverviewTab = ({
  graphRef,
  graphRef2,
  onGraphsCaptured,
  structure,
  userPermissionOnStructure,
  openDrawerNewInspection,
  setOpenDrawerNewInspection,
}) => [
  {
    level: '',
    label: 'Overview',
    content: (
      <TabOverview
        graphRef={graphRef}
        graphRef2={graphRef2}
        onGraphsCaptured={onGraphsCaptured}
        structure={structure}
        userPermissionOnStructure={userPermissionOnStructure}
        openDrawerNewInspection={openDrawerNewInspection}
        setOpenDrawerNewInspection={setOpenDrawerNewInspection}
      />
    ),
    disabled: false,
    value: 0,
  },
  {
    level: 'L0',
    label: 'Riepilogo censimento e anagrafica',
    icon: <img src={iconL0} alt="L0" />,
    iconPosition: 'start',
    content: (
      <TabL0
        structure={structure}
        userPermissionOnStructure={userPermissionOnStructure}
        openDrawerNewInspection={openDrawerNewInspection}
        setOpenDrawerNewInspection={setOpenDrawerNewInspection}
      />
    ),
    // content: <TabCreateInspection tabs={contextAccordionTabsL0} />,
    disabled: false,
    value: 1,
  },
  {
    level: 'L1',
    label: 'Riepilogo ispezioni',
    icon: <img src={iconL1} alt="L1" />,
    iconPosition: 'start',
    // content: <TabCreateInspection tabs={contextAccordionTabsL1} />,
    disabled: false,
    value: 2,
    content: (
      <TabL1
        structure={structure}
        userPermissionOnStructure={userPermissionOnStructure}
        openDrawerNewInspection={openDrawerNewInspection}
        setOpenDrawerNewInspection={setOpenDrawerNewInspection}
      />
    ),
  },
  {
    level: 'L2',
    label: 'Riepilogo classi di attenzione',
    icon: <img src={iconL2} alt="L2" />,
    iconPosition: 'start',
    content: (
      <L2Cda
        structure={structure}
        userPermissionOnStructure={userPermissionOnStructure}
        openDrawerNewInspection={openDrawerNewInspection}
        setOpenDrawerNewInspection={setOpenDrawerNewInspection}
      />
    ),
    disabled: false,
    value: 3,
  },
  {
    level: 'L3',
    // Issue #1021, punto 11 — solo la tab del Dettaglio Ponte (questa
    // funzione, getOverviewTab): la tab omonima dentro l'attività
    // (getNewInspectionTabs sopra) resta "Idraulica", non va rinominata.
    // Riapertura 2026-09-04, punto 11 — "L3" compariva due volte (icona +
    // prefisso testuale), a differenza di L0/L1/L2 (icona sola): rimosso il
    // prefisso, l'icona basta.
    label: 'Riepilogo valutazione preliminare',
    icon: <img src={iconL3} alt="L3" />,
    iconPosition: 'start',
    content: (
      <TabL3
        structure={structure}
        userPermissionOnStructure={userPermissionOnStructure}
        openDrawerNewInspection={openDrawerNewInspection}
        setOpenDrawerNewInspection={setOpenDrawerNewInspection}
      />
    ),
    // Issue #1021, checklist punto 6 (2026-09-01) — dal BE, GET
    // bridges/:id/overview/L3 risponde ora 403 quando nessuno dei tre
    // soggetti ha il modulo L3 attivo (prima era un no-op in sola lettura):
    // la tab va disabilitata prima che l'utente ci clicchi dentro, altrimenti
    // vedrebbe un errore anziché un riepilogo vuoto/assente.
    disabled: !hasL3ModuleAccess(structure?.l3Access),
    value: 4,
  },
  {
    level: 'L4',
    label: 'Riepilogo verifica accurata',
    icon: <img src={iconL4} alt="L4" />,
    iconPosition: 'start',
    // content: <TabCreateInspection tabs={contextAccordionTabsOthers} />,
    disabled: true,
    value: 5,
    content: <p></p>,
  },
  {
    level: 'L5',
    label: 'Riepilogo sorveglianza e monitoraggio',
    icon: <img src={iconL5} alt="L5" />,
    iconPosition: 'start',
    // content: <TabCreateInspection tabs={contextAccordionTabsOthers} />,
    disabled: true,
    value: 6,
    content: <p></p>,
  },
];
